import { getRuntimeBooleanConfig, getRuntimeConfig, getRuntimeNumberConfig } from './runtimeConfig';

export const ENVIRONMENT_CONFIG = {
  ACCESS_MANAGEMENT_SERVICE: getRuntimeConfig(
    'VITE_ACCESS_MANAGEMENT_SERVICE',
    'http://localhost:3000'
  ),
  CONSUMER_PRICE_SERVICE: getRuntimeConfig('VITE_CONSUMER_PRICE_SERVICE', 'http://localhost:3003'),
  ANALYSIS_SERVICE: getRuntimeConfig('VITE_ANALYSIS_SERVICE', 'http://localhost:3006'),
  NLP_SERVICE: getRuntimeConfig('VITE_NLP_SERVICE', 'http://localhost:5000'),
  ENCRYPTION_KEY: getRuntimeConfig('VITE_ENC_KEY', 'inc@key'),
  COUNTRY_CODE: getRuntimeConfig('VITE_COUNTRY_CODE', 'HN'),
  RESEND_TIMER: getRuntimeNumberConfig('VITE_RESEND_TIMER', 300),
  OTPENABLED: getRuntimeBooleanConfig('VITE_OTP_ENABLE', false),
  DEFAULT_LAN: getRuntimeConfig('VITE_DEFAULT_LAN', 'en'),
  DISPLAY_TRANSLATIONS: getRuntimeBooleanConfig('VITE_DISPLAY_TRANSLATIONS', true),
  SESSION_TIMEOUT: getRuntimeNumberConfig('VITE_SESSION_TIMEOUT', 300000),
  I18_DEBUG_LOGS: getRuntimeBooleanConfig('VITE_I18_DEBUG_LOGS', false),
  BASIC_FOOD_BASKET_NAME: getRuntimeConfig(
    'VITE_BASIC_FOOD_BASKET_NAME',
    'Canasta Básica de Alimentación'
  ),
  INDEXED_DB_VERSION: getRuntimeNumberConfig('VITE_INDEXED_DB_VERSION', 26),
  SYNC_ENGINE_INTERVAL: getRuntimeNumberConfig('VITE_SYNC_ENGINE_INTERVAL', 30000),
  REFERENCE_SYNC_INTERVAL: getRuntimeNumberConfig('VITE_REFERENCE_SYNC_INTERVAL', 60000),
  LOCALE_LOAD_TIMEOUT: getRuntimeNumberConfig('VITE_LOCALE_LOAD_TIMEOUT', 4000),
};
